import { setDimensionsConcreteMember } from "@reducers/selectors/dimension/actions";
import { setRebarReinforcementNz } from "@reducers/selectors/loads/actions";
import { setScrewPaddingS, setScrewPaddingD, setScrewShiftC, setScrewShiftC1 } from "../screw/actions";

export const SET_REINFORCEMENT_WIDTH = 'SET_REINFORCEMENT_WIDTH';
export const SET_REINFORCEMENT_HEIGHT = 'SET_REINFORCEMENT_HEIGHT';
export const SET_REINFORCEMENT_DEPTH = 'SET_REINFORCEMENT_DEPTH';
export const SET_REINFORCEMENT_NZ = 'SET_REINFORCEMENT_NZ';
export const SET_REINFORCEMENT_TYPE = 'SET_REINFORCEMENT_TYPE';
export const SET_REINFORCEMENT_OPTIONS = 'SET_REINFORCEMENT_OPTIONS';

export const RESET_REINFORCEMENT = 'RESET_REINFORCEMENT';
export const SET_REINFORCEMENT_STATE = 'SET_REINFORCEMENT_STATE';

/*
  Action creators
 */
export function setReinforcementWidth(options) {
  return (dispatch) => {
    if (options.hasOwnProperty('value'))
      dispatch(setDimensionsConcreteMember({
        wb: options.value  
      }));
    dispatch({ type: SET_REINFORCEMENT_WIDTH, options });
  };
}

export function setReinforcementHeight(options) {
  return (dispatch) => {
    if (options.hasOwnProperty('value'))
      dispatch(setDimensionsConcreteMember({
        hb: options.value 
      }));
    dispatch({ type: SET_REINFORCEMENT_HEIGHT, options });
  };
}

export function setReinforcementDepth(options) {
  return (dispatch) => {
    if (options.hasOwnProperty('value'))
      dispatch(setDimensionsConcreteMember({
        lb: options.value  
      }));
    dispatch({ type: SET_REINFORCEMENT_DEPTH, options });
  };
}

export function setReinforcementNz(value) {
  return { type: SET_REINFORCEMENT_NZ, value };
}

export function setReinforcementType(value) {
  return { type: SET_REINFORCEMENT_TYPE, value };
}

export function setReinforcementOptions(options) {
  return (dispatch) => {
    if (options.hasOwnProperty('screw')){
      if (options.screw.hasOwnProperty('padding')){
        if(options.screw.padding.hasOwnProperty('s')) {
          dispatch(setScrewPaddingS(options.screw.padding.s));
        }
        if(options.screw.padding.hasOwnProperty('d')) {
          dispatch(setScrewPaddingD(options.screw.padding.d));
        }
      }
      if (options.screw.hasOwnProperty('shift')){
        if(options.screw.shift.hasOwnProperty('c')) {
          dispatch(setScrewShiftC(options.screw.shift.c));
        }
        if(options.screw.shift.hasOwnProperty('c1')) {
          dispatch(setScrewShiftC1(options.screw.shift.c1));
        }
      }
    }
    if (options.hasOwnProperty('width')){
      dispatch(setReinforcementWidth(options.width));
    }
    if (options.hasOwnProperty('height')){
      dispatch(setReinforcementHeight(options.height));
    }
    if (options.hasOwnProperty('depth')){
      dispatch(setReinforcementDepth(options.depth));
    }
    if (options.hasOwnProperty('actionType')){
      if (options.actionType.hasOwnProperty('value'))
        dispatch(setRebarReinforcementNz(options.actionType.value));
    }
    
    dispatch({ type: SET_REINFORCEMENT_OPTIONS, options});
  };
}

export function resetReinforcement() {
  return { type: RESET_REINFORCEMENT};
}

export function setReinforcementState(state) {
  return { type: SET_REINFORCEMENT_STATE, state };
}



// WEBPACK FOOTER //
// ./src/reducers/options/reinforcement/actions.js